/*
 * Copyright (c)  CYBERKOALA LLC 2025.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */

type HandleScreenShareMuteOnHideParams = {
  id: string;
  hidden: boolean;
  getVolume: (id: string) => number;
  setVolume: (id: string, vol: number) => void;
  previousVolume: number;
  setPreviousVolume: (vol: number) => void;
};

// TODO: restore previous volume from settings
export function handleScreenShareMuteOnHide({
  id,
  hidden,
  getVolume,
  setVolume,
  previousVolume,
  setPreviousVolume,
}: HandleScreenShareMuteOnHideParams) {
  const screenShareId = `${id}_screenShare`;
  const currentVolume = getVolume(screenShareId);

  if (hidden) {
    setPreviousVolume(currentVolume);
    setVolume(screenShareId, 0);
  } else {
    // Восстанавливаем звук из previousVolume (который был сохранен до скрытия)
    // previousVolume хранит значение из volumes[screenShareId] на момент скрытия
    setVolume(screenShareId, previousVolume);
  }
}
